import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Link from '../../links/Link/Link';

function ShareButton({ xHref, facebookHref, shareEmailAddress }) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    const options = ref.current.querySelectorAll('div.content__share-options a');

    options.forEach((item, index) => {
      item.addEventListener('focus', () => {
        setIsOpen(true);
      });

      item.addEventListener('blur', () => {
        setIsOpen(false);
      });
    });
  });

  return (
    <div
      ref={ref}
      className={classNames('button button--icon icon--left icon--share content__share-this-page', {
        active: isOpen
      })}
      onClick={() => setIsOpen(!isOpen)}
      role="button"
      aria-expanded={isOpen}
    >
      <span>{t('styleguide:footer_share_page_text')}</span>
      <div className="content__share-options" aria-hidden={!isOpen} tabIndex={!isOpen ? '-1' : '0'}>
        <Link href={xHref} target="_self" className="social social--xcom">
          {t('styleguide:footer_x')}
        </Link>
        <Link href={facebookHref} target="_self" className="social social--facebook-simple">
          {t('styleguide:footer_facebook')}
        </Link>
        <Link href={shareEmailAddress} className="social social--email">
          {t('styleguide:footer_email')}
        </Link>
      </div>
    </div>
  );
}

ShareButton.propTypes = {
  /**
   * The X URL
   */
  xHref: PropTypes.string,
  /**
   * The facebook URL
   */
  facebookHref: PropTypes.string,
  /**
   * The share email address
   */
  shareEmailAddress: PropTypes.string
};

export default ShareButton;
